import { QuizLearnerIdentityType } from 'app/types'

const getIdentityKey = (orgId: string) => `guidde-quiz-identity-${orgId}`

const getDismissedKey = (playbookId: string) => `guidde-quiz-identification-dismissed-${playbookId}`

export const readQuizIdentity = (uid: string, orgId: string): QuizLearnerIdentityType | null => {
    try {
        const raw = window.sessionStorage.getItem(getIdentityKey(orgId))
        if (!raw) return null

        const stored = JSON.parse(raw) as { uid?: unknown; email?: unknown; name?: unknown }
        if (stored.uid !== uid) return null

        const email = typeof stored.email === 'string' && stored.email ? stored.email : undefined
        const name = typeof stored.name === 'string' && stored.name ? stored.name : undefined
        if (!email && !name) return null

        return { ...(email && { email }), ...(name && { name }) }
    } catch {
        return null
    }
}

export const writeQuizIdentity = (uid: string, orgId: string, identity: QuizLearnerIdentityType) => {
    try {
        window.sessionStorage.setItem(getIdentityKey(orgId), JSON.stringify({ uid, ...identity }))
    } catch (error) {
        console.error('[sessionStorage set error:]', error)
    }
}

export const readIdentificationDismissed = (playbookId: string): boolean => {
    try {
        return window.sessionStorage.getItem(getDismissedKey(playbookId)) === 'true'
    } catch {
        return false
    }
}

export const writeIdentificationDismissed = (playbookId: string) => {
    try {
        window.sessionStorage.setItem(getDismissedKey(playbookId), 'true')
    } catch (error) {
        console.error('[sessionStorage set error:]', error)
    }
}
